export const baseURL = "https://release.edayaapp.com";
export const redirectUrl = "https://release.edayaapp.com/guestweb-release";
export const AnalyticsKey = "G-04GWWYKDZL";

// export const baseURL = "https://edayaapp.com";
// export const redirectUrl = "https://edayaapp.com/guestweb";
// export const AnalyticsKey = "G-JDTY8DDR24";

// export const baseURL = "http://127.0.0.1:8000";
//  export const redirectUrl = "http://127.0.0.1:8000";
// export const redirectUrl = "http://localhost:3000/";
// export const baseURL = "http://localhost/vishnu/edaya_design_full/public"; 

 export const vapidKey = 'BM4ogRdB3Qx5iIbgDC-R4YnbodQhfgSt3g_YY0X-xzDO-E7K7vQ9Tu_JcfGLTLpp7lzXFtEHF9-UbJciWl_RidY';
